import { trackEvent } from '../../support-and-tracking/analytics-actions';
import styles from './shareAfterGive.module.less';
import NativeShareButton from './NativeShareButton';
import { Icon } from '@sb1/ffe-icons-react';
import image from '@sb1/ffe-icons/icons/open/300/lg/image.svg';
import { useProject } from '../project-hooks/useProject';
import InstagramShareInstructionsModal from './share-instructions-modal/InstagramShareInstructionsModal';
import { useRef } from 'react';
import FacebookShareButton from './FacebookShareButton';
import { SecondaryButton } from '@sb1/ffe-buttons-react';
import { MicroText } from '@sb1/ffe-core-react';
import Image from '../../components/image/Image';
import { Modal } from '@sb1/ffe-modals-react';
import { ImageModalContainer } from './share-on-project-modal/ImageModalContainer';
import { useProjectShareTrackingProperties } from '../project-hooks/useProjectShareTrackingProperties';
import FacebookShareInstructionsModal from './share-instructions-modal/FacebookShareInstructionsModal';

const SharePostMobileButtons = ({ prettyUrlToShare, imageUrl, isTradingCard }) => {
    const project = useProject();
    const instagramModalRef = useRef(null);
    const facebookModalRef = useRef(null);
    const imageModalRef = useRef(null);
    const trackingProperties = useProjectShareTrackingProperties();

    const trackClick = (channel) => {
        trackEvent('support', 'share', {
            channel,
            ...trackingProperties,
            isTradingCard: isTradingCard,
        });
    };

    return (
        <div className={styles.shareButtons}>
            {isTradingCard && (
                <div className={styles.buttonGroup}>
                    <SecondaryButton
                        className={[styles.roundButton, styles.instagramLogoButton].join(' ')}
                        onClick={() => {
                            facebookModalRef?.current?.open();
                            trackClick('show-facebook-modal');
                        }}
                        aria-label={'Del på Facebook'}
                        iconOnly
                    >
                        <Image src="fb-logo2.png" height={48} width={48} />
                    </SecondaryButton>
                    <MicroText className={styles.shareDescription} aria-hidden>
                        Facebook
                    </MicroText>
                </div>
            )}
            {!isTradingCard && (
                <FacebookShareButton
                    buttonWrapperClassName={styles.buttonGroup}
                    urlToShare={prettyUrlToShare}
                    titleToShare={project.title}
                    trackEventFunction={() =>
                        trackEvent('support', 'share', {
                            channel: 'facebook',
                            ...trackingProperties,
                        })
                    }
                    buttonClassName={styles.button}
                    logoAsButton
                    isNative
                />
            )}
            <div className={styles.buttonGroup}>
                <SecondaryButton
                    className={[styles.button, styles.instagramLogoButton].join(' ')}
                    onClick={() => {
                        instagramModalRef?.current?.open();
                        trackClick('show-instagram-modal');
                    }}
                    ariaLabel={'Del på Instagram'}
                    iconOnly
                >
                    <Image src="instagram_story.svg" height={48} width={48} />
                </SecondaryButton>
                <MicroText className={styles.shareDescription} aria-hidden>
                    Instagram-historie
                </MicroText>
            </div>
            <div className={styles.buttonGroup}>
                <SecondaryButton
                    onClick={() => {
                        imageModalRef?.current?.open();
                        trackClick('instagram-story');
                    }}
                    className={styles.button}
                    ariaLabel={'Del bilde'}
                    iconOnly
                >
                    <Icon fileUrl={image} size="lg" />
                </SecondaryButton>
                <MicroText className={styles.shareDescription} aria-hidden>
                    Bilde
                </MicroText>
            </div>
            <NativeShareButton
                className={styles.stickyNativeShareButton}
                urlToShare={isTradingCard ? undefined : prettyUrlToShare}
                titleToShare={project.title}
                trackEventFunction={() =>
                    trackEvent('support', 'share', {
                        channel: 'native_share',
                        ...trackingProperties,
                    })
                }
                shareWithPicture={!!imageUrl}
                shareImageUrl={imageUrl ?? null}
                text={isTradingCard ? 'Del fotballkort' : null}
            />
            <InstagramShareInstructionsModal
                ref={instagramModalRef}
                urlToShare={prettyUrlToShare}
                projectId={project?.id}
                projectTitle={project?.title}
                trackingProperties={trackingProperties}
                showBackButton={false}
                tradingCardImageUrl={imageUrl}
            />
            <FacebookShareInstructionsModal
                ref={facebookModalRef}
                urlToShare={prettyUrlToShare}
                trackingProperties={trackingProperties}
                showBackButton={false}
                tradingCardImageUrl={imageUrl}
            />
            <Modal ref={imageModalRef} ariaLabelledby="share-modal-title">
                <ImageModalContainer
                    trackingProperties={trackingProperties}
                    heading={'Delingsbilde'}
                    subHeading={'Del bildet i sosiale medier for å vise din støtte til spleisen.'}
                    url={imageUrl ?? `/api/public/project/${project?.id}/shareImage`}
                    type={'image'}
                    downloadText={'Last ned bildet'}
                />
            </Modal>
        </div>
    );
};

export default SharePostMobileButtons;
